import { EventTextSizes } from '@/types/gql.generated';

export const LARGE_EVENT_TEXT_SCALE = 1.22;

export const getEventTextScale = (eventTextSize?: EventTextSizes) =>
  eventTextSize === EventTextSizes.Large ? LARGE_EVENT_TEXT_SCALE : 1;
